import { compose, applyMiddleware, createStore } from 'redux'
import thunk from 'redux-thunk'
import rootReducer from './reducer/index'

const middlewares = [thunk]
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
export const store = createStore(rootReducer, composeEnhancer(applyMiddleware(...middlewares)))
